<template>
    <div class="notifs flex p-2 border-b bg-white">
        <div class="flex-inline text-center px-8 py-2 border-r">
            <i class="fa fa-tag fa-lg text-brand"></i>
            <span class="text-lg m-1 text-black">{{notif_counts.unfiled}}</span>
        </div>
        <div class="flex-inline text-center px-8 py-2 border-r">
            <i class="fa fa-comment fa-lg text-brand"></i>
            <span class="text-lg m-1 text-black">{{notif_counts.discussions}}</span>
        </div>
        <div class="flex-inline text-center px-8 py-2 border-r">
            <i class="fa fa-check-circle fa-lg text-brand"></i>
            <span class="text-lg m-1 text-black">{{notif_counts.tasks}}</span>
        </div>
        <div class="flex-inline text-center px-8 py-2">
            <i class="fa fa-calendar-check fa-lg text-brand"></i>
            <span class="text-lg m-1 text-black">{{notif_counts.events}}</span>
        </div>
    </div>
</template>

<script>
export default {
  props: ["value"],

  data() {
    return {
      notif_counts: _.cloneDeep(this.value)
    };
  },

  mounted() {
    this.getAllNotifCounts();

    this.$ebus.$on("update-unfiled", () => {
      this.updateUnfiled();
    });

    this.$ebus.$on("update-discussion-count", () => {
      this.updateDiscussions();
    });

    this.$ebus.$on("update-task-count", () => {
      this.updateTasks();
    });

    this.$ebus.$on("update-events-count", () => {
      this.updateEvents();
    });
  },

  methods: {
    getAllNotifCounts() {
      this.updateUnfiled();

      this.updateDiscussions();

      this.updateTasks();

      this.updateEvents();
    },

    updateEvents() {
      axios
        .get("api/users/count-pending-events", {
          params: {
            own_only: 1,
            from_start_at: moment()
              .day("-1")
              .format("YYYY-MM-DD HH:mm:ss")
          }
        })
        .then(({ data }) => {
          if (data.success) {
            this.notif_counts.events = data.count;
          }
        });
    },

    updateUnfiled() {
      axios.get("api/users/count-unfiled").then(({ data }) => {
        if (data.success) {
          this.notif_counts.unfiled = data.count;
        }
      });
    },

    updateDiscussions() {
      axios.get("api/users/count-unread-discussions").then(({ data }) => {
        if (data.success) {
          this.notif_counts.discussions = data.count;
        }
      });
    },

    updateTasks() {
      axios.get("api/users/count-pending-tasks").then(({ data }) => {
        if (data.success) {
          this.notif_counts.tasks = data.count;
        }
      });
    }
  },

  watch: {
    notif_counts: {
      deep: true,
      handler: function() {
        this.$emit("input", this.notif_counts);
      }
    }
  }
};
</script>

<style>
</style>
